<form [formGroup]="form" class="space-y-8">
  <!-- Type Selection -->
  <div class="flex flex-col space-y-2">

    <beautyapp-select
      formControlName="hospitalizationResult"
      [data]="hospitalizationResults()"
      displayMember="value"
      valueMember="id"
      placeholder="აირჩიეთ ჰოსპიტალიზაციის შედეგი"
      label="ჰოსპიტალიზაციის შედეგი"
      size="large"
    />
    <beautyapp-select
      formControlName="conditionAtTheMoment"
      [data]="conditionAtTheMoment()"
      displayMember="value"
      valueMember="id"
      placeholder="აირჩიეთ დაავადების გამოსავალი"
      label="დაავადების გამოსავალი"
      size="large"
    />
    <beautyapp-select
      formControlName="ehrVisibleStatus"
      [data]="ehrVisibilityStatus()"
      displayMember="value"
      valueMember="id"
      placeholder="აირჩიეთ მონაცემთა სტატუსები (ხილვადობა)"
      label="მონაცემთა სტატუსები (ხილვადობა)"
      size="large"
    />
  </div>

</form>

<div *nzModalFooter>
  <button nz-button nzType="default" nzSize="large" (click)="modal.close()">{{'buttons.close' | translate}}</button>
  <button  type="button" nz-button nzSize="large" nzType="primary"
           (click)="submit()"
           [disabled]="form.invalid"
            [nzLoading]="loading()"
  >{{'buttons.save' | translate}}</button>
</div>
